import { headerFunc } from "./common/_header";
import { commonFunc, commonLoadFunc } from "./common/_common";

$(window).on("DOMContentLoaded", function () {
  commonFunc();
  headerFunc();
});

$(window).on("load", function () {
  commonLoadFunc();
});
